import { IconButton } from "@mui/material";
import React, { useState } from "react";

interface ByzToggleIconButtonProps {
  iconOn: string;
  iconOff: string;
  altText: string;
  defaultState?: boolean;
  value?: boolean;
  disabled?: boolean;
  onClick?: (state: boolean) => void;
}

const ByzToggleIconButton: React.FC<ByzToggleIconButtonProps> = ({
  iconOn,
  iconOff,
  altText,
  defaultState = false,
  value,
  disabled = false,
  onClick,
}) => {
  const [internalToggled, setInternalToggled] = useState(defaultState);

  const isToggled = value !== undefined ? value : internalToggled;

  const handleClick = () => {
    if (disabled) return;
    const newState = !isToggled;
    if (value === undefined) {
      setInternalToggled(newState);
    }
    if (onClick) {
      onClick(newState);
    }
  };

  return (
    <IconButton aria-label={altText} onClick={handleClick} disabled={disabled}>
      <img
        src={isToggled ? iconOn : iconOff}
        alt={altText}
        width="20"
        height="20"
        style={{ opacity: disabled ? 0.5 : 1 }}
      />
    </IconButton>
  );
};

export default ByzToggleIconButton;
